module.exports = __webpack_public_path__ + "img/ZJ5247.35976791.png";